<template>
  <div class="home-box">
    <m-header :homestate="homestate"></m-header>
    <!-- 会员弹出框 -->
    <memberBug class="memberBug" :isShow="isShow"></memberBug>
    <!-- banner -->
    <div class="banner">

      <swiper class="banner-swiper" :options="swiperBanner">
        <swiper-slide v-for="inner in bannerList" :key="inner.bannerId" class="banner-swiper-item">
          <div class="banner-swiper-item-box" @click="goBanner(inner)">
            <div class="banner-img" :style="{
              backgroundImage: `url(${linkAllImgUrl(inner.imageUrl)})`
            }"></div>
          </div>
        </swiper-slide>
        <div class="banner-pagination" slot="pagination"></div>
      </swiper>

      <div class="center">

        <h1 class="main">高质量3D模型</h1>
        <div class="search-input">
          <input id="NavTextField" type="text" v-model="searchText" autocomplete="off" placeholder="搜索"
            v-on:keyup.enter="searchFun" />

          <span class="search-btn" @click="searchFun">
            <img src="../assets/icon_search.png" alt />
          </span>
        </div>
      </div>
    </div>
    <div style="height: 60px;"></div>
    <!-- 分类 -->
    <div class="home-body">
      <!-- 普通模型 -->
      <div class="class-swiper">
        <swiper class="swiper" key="classify-list" :options="swiperOption">
          <swiper-slide class="swiper-item" v-for="item in classArr" :key="item.categoryId">
            <div class="swiper-item-box" @click="goPage(item.categoryId, item.categoryName, item.type)">
              <img :src="linkAllImgUrl(item.imgUrl)" />
              <p>{{ item.categoryName }}</p>
            </div>
          </swiper-slide>
        </swiper>
        <div v-show="classArr.length > 9" class="swiper-button-prev classify-prev" slot="button-prev"></div>
        <div v-show="classArr.length > 9" class="swiper-button-next classify-next" slot="button-next"></div>
      </div>
      <!-- 父子模型 -->
      <template v-for="(item, itemIndex) in parentSonArr">
        <div v-if="item" class="category-box" :key="item.categoryId">
          <div class="category-title">
            <div class="title-line"></div>
            <div class="title-content">
              <h2 @click="goPage(item.categoryId, item.categoryName)">{{ item.categoryName }}</h2>
            </div>
          </div>

          <div class="category-swiper-box">
            <swiper class="category-swiper" :options="item.mSwiper">
              <swiper-slide v-for="inner in item.menuCategoryList" :key="inner.categoryId" class="category-swiper-item">
                <div class="category-swiper-item-box" @click="goPage(inner.categoryId, item.categoryName)">
                  <img :src="linkAllImgUrl(inner.imgUrl)" />
                  <p>{{ inner.categoryName }}</p>
                </div>
              </swiper-slide>
            </swiper>
            <div v-show="item.menuCategoryList.length > 6" :class="['swiper-button-prev', `category-prev${itemIndex}`]"
              slot="button-prev"></div>
            <div v-show="item.menuCategoryList.length > 6" :class="['swiper-button-next', `category-next${itemIndex}`]"
              slot="button-next"></div>
          </div>
        </div>
      </template>
    </div>
    <m-footer></m-footer>
  </div>
</template>

<script>
import { homeClassApi } from "@/api/home";
import { getBannerApi, myAccountApi } from "@/api/user";
import commonMixin from "@/mixins/commonMixin";
import { alipayBindApi } from "@/api/login";
import memberBug from '@/components/memberBug/index.vue'
import { mapGetters } from "vuex";

export default {
  mixins: [commonMixin],
  components: {
    memberBug,
    //rightMemTxt
  },
  data () {
    return {
      // 搜索分类列表
      searchArr: [],
      searchItem: {},
      searchText: '',
      /* 普通模型获取分类 */
      classArr: [],
      /* banner swiper */
      bannerList: [],
      swiperBanner: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.banner-pagination'
        }
      },
      /* 普通模型swiper */
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 25,
        direction: "horizontal",
        navigation: {
          nextEl: ".classify-next",
          prevEl: ".classify-prev"
        }
      },
      /* 父子模型获取分类 */
      parentSonArr: [],
      isShow: true,
      homestate: null
    };
  },
  created () {

    this.getBanner();
    this.getSearchClass();
    this.getClass();
    this.getPsClassApiFun();
    if (!document.cookie.includes("ad=")) {
      this.setcookie();
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  },
  mounted () {
    if (this.GET_USER_INFO.token == "") {
      // 没登录
      this.homestate = 1 || null

    } else {

      myAccountApi().then(res => {
        if (res.code === 200) {
          this.homestate = res.data.memberState
          localStorage.setItem('memberState', res.data.memberState)
        }
      })
    }

  },
  computed: {
    ...mapGetters(["GET_USER_INFO"]),
  },

  methods: {
    setcookie () {
      let d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000);//24小时
      // d.setTime(d.getTime() + 1 * 60 * 60 * 1000);//1小时
      //d.setTime(d.getTime() + 1 * 60 * 1000);//1分钟
      // ad=popup-ad   键值对形式：name=key   expires 有效期
      document.cookie = "ad=popup-ad;expires= " + d.toGMTString();
      let result = document.cookie;
      return result;
    },
    bbb () {
      alipayBindApi().then(res => {
        window.location.href = res.data;
      })
    },
    getBanner () {
      /* 1 首页 2 搜索页 3 活动页 */
      getBannerApi({ position: 1 }).then(res => {
        if (res.code == 200) {
          this.bannerList = res.data;
        }
      });
    },
    goBanner (item) {

      if (item.type == 2) {
        window.open(item.jumpUrl, '_blank')
      }
    },
    goPage (categoryId, name, type) {

      this.$router.push({
        path: '/search',
        query: {
          categoryId,
          type
        }
      })

    },
    getSearchClass () {
      const params = {
        type: null,
        parentId: 1,
        isReturnParent: 0,
        showNum: 99
      };
      homeClassApi(params).then(res => {
        if (res.code == 200) {
          this.searchArr = res.data;
          this.searchItem = this.searchArr[0];
        }
      });
    },
    clickSearch (item) {
      this.searchItem = item;
    },
    searchFun () {
      localStorage.setItem("emptyRes", 0);
      if (this.searchText) {
        this.$router.push({
          path: '/search',
          query: {
            // categoryId: this.searchItem.categoryId,
            name: this.searchText
          }
        })
      }
    },
    getClass () {
      const params = {
        type: 0,
        parentId: 1,
        isReturnParent: 0,
        showNum: 15
      };

      homeClassApi(params).then(res => {
        if (res.code == 200) {
          this.classArr = res.data;
        }
      });
    },
    getPsClassApiFun () {
      const params = {
        type: 1,
        parentId: 1,
        isReturnParent: 0,
        showNum: 7
      };

      homeClassApi(params).then(res => {
        if (res.code == 200) {
          this.getPsChild(res.data);
        }
      });
    },
    getPsChild (arr) {
      arr.forEach((item, index) => {
        const { categoryId } = item;

        const params = {
          type: 1,
          parentId: categoryId,
          isReturnParent: 0,
          showNum: 15
        };

        homeClassApi(params).then(res => {
          if (res.code == 200) {
            this.$set(this.parentSonArr, index, {
              ...item,
              menuCategoryList: res.data,
              mSwiper: {
                slidesPerView: "auto",
                spaceBetween: 25,
                direction: "horizontal",
                navigation: {
                  nextEl: `.category-next${index}`,
                  prevEl: `.category-prev${index}`
                }
              }
            });
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.home-box {
  // padding-bottom: 100px;
  min-width: 1200px;
}

.banner {
  overflow: hidden;
  margin-bottom: 0;
  width: 100%;
  position: relative;
  font-family: Lato, "Source Sans Pro", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-weight: 300;
  background-size: cover;
  height: 700px;
  background-position: center;

  .banner-swiper {
    width: 100%;
    height: 700px;

    .banner-swiper-item {
      width: 100%;
      height: 700px;

      .banner-swiper-item-box {
        width: 100%;
        height: 700px;

        .banner-img {
          width: 100%;
          height: 700px;
          background-size: cover;
          background-position: center;
        }
      }
    }

    .banner-pagination {
      position: absolute;
      z-index: 9;
      text-align: center;
    }
  }

  .center {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: 250px auto 0;
    z-index: 99;
    width: 610px;
    // background: green;
    font-family: Lato, "Source Sans Pro", "Helvetica Neue", Helvetica, Arial,
      sans-serif;

    .main {
      color: #fff;
      font-family: ChronicleDisplay-Italic, "Source Sans Pro", "Helvetica Neue",
        Helvetica, Arial, sans-serif;
      font-size: 48px;
      font-style: italic;
      font-weight: 300;
      line-height: 58px;
      text-align: center;
      margin-bottom: 26px;
    }

    .search-input {
      height: 50px;
      width: 550px;
      border: 1px solid #ff8135;
      border-radius: 5px;
      box-shadow: inset 0 1px 3px 0 rgb(0 0 0 / 50%);
      padding: 0 13px 0 0;
      font-size: 18px;
      background-color: rgba(255, 255, 255, 0.95);
      position: relative;
      max-width: 620px;
      margin: 0 auto;
      display: table;

      #NavTextField {
        background: 0 0;
        border: none;
        height: 50px;
        // width: 360px;
        width: 480px;
        float: left;
        padding-left: 13px;
        outline: none;
      }

      .delimiter {
        line-height: 48px;
        // margin-top: 15px;
        font-size: 24px;
        color: #a9a9a9;
      }

      .search-btn {
        display: inline-block;
        vertical-align: top;
        // padding-left: 20px;
        width: 50px;
        height: 50px;
        text-align: center;
        cursor: pointer;

        img {
          margin-top: 15px;
          width: 20px;
          height: 20px;
        }
      }

      .input-group-btn {
        float: right;
        width: 106px;
        height: 50px;
        cursor: pointer;

        &:hover {
          .search-list {
            display: block;
          }
        }
      }

      #NavButton {
        margin-top: 8px;
        padding: 0;
        width: 100%;
        height: 34px;
        color: #333;
        white-space: nowrap;
        border: none;
        background: none;
        cursor: pointer;

        span {
          display: inline-block;
          vertical-align: top;
        }

        .glyphicon {
          display: inline-block;
          vertical-align: top;
          margin-left: 5px;
          width: 15px;
          height: 15px;
          background: url("~@/assets/icon_down.png") center center no-repeat;
          background-size: cover;
        }
      }
    }
  }
}

.notice {
  margin-bottom: 30px;
  max-height: 100px;
  min-height: 50px;
  background-color: #ff8135;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 50%);
  padding: 13px;
  font-size: 18px;
  font-family: Lato, "Source Sans Pro", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  box-sizing: border-box;

  .notice-link {
    text-decoration: none;
  }

  .notice-text {
    line-height: 24px;
    text-align: center;
    color: #ffffff;
  }
}

/* 分类 */
.home-body {
  margin: 0 auto;
  width: 80%;
}

.class-swiper {
  position: relative;
  margin-bottom: 40px;

  .swiper-button-prev {
    transform: translateX(-60px);
  }

  .swiper-button-next {
    transform: translateX(60px);
  }

  .swiper {
    height: 180px;
    padding-top: 20px;

    .swiper-item {
      width: 150px;
      height: 130px;
      transition: all 0.2s;

      &:hover {
        transform: scale(1.2);
      }

      .swiper-item-box {
        text-align: center;
        cursor: pointer;

        &:hover {
          p {
            color: #333333;
          }
        }

        img {
          width: 100px;
          height: 100px;
        }

        p {
          color: #969696;
          display: inline-block;
          font-size: 15px;
          font-weight: 300;
          line-height: 20px;
          margin: 5px 0 0;
          overflow: hidden;
          text-shadow: 0 1px 0 #fff;
          text-transform: uppercase;
          width: 100%;
        }
      }
    }
  }
}

.category-box {
  display: inline-block;
  width: 100%;
  margin-bottom: 30px;

  .category-title {
    margin: 18px 0;
    text-align: center;

    .title-line {
      height: 2px;
      border-top: 1px solid #e4e4e4;
      border-bottom: 1px solid #fff;
      border-left: 0;
      border-right: 0;
    }

    .title-content {
      margin-top: -18px;
      text-shadow: 1px 1px 0 #fff;

      a {
        text-decoration: none;
      }

      h2 {
        cursor: pointer;
        color: #969696;
        font-size: 30px;
        padding: 0 5px;
        display: inline;
        text-transform: uppercase;
        font-weight: 300;
        background-color: #f7f7f7;
      }
    }
  }

  .category-swiper-box {
    position: relative;
    min-height: 230px;

    // margin-bottom: 40px;
    .swiper-button-prev {
      transform: translateX(-60px);
    }

    .swiper-button-next {
      transform: translateX(60px);
    }

    .category-swiper {

      //padding-left: 50px;
      //padding-right: 50px;
      .category-swiper-item {
        &:first-of-type {
          margin-left: 20px;
        }

        transform: scale(0.9);
        transition: all 0.2s;

        &:hover {
          transform: scale(1);
          z-index: 20;
        }

        width: 190px;
        height: 250px;
        padding-top: 20px;

        .category-swiper-item-box {
          text-align: center;
          height: 230px;
          cursor: pointer;

          &:hover {
            p {
              color: #242424;
            }
          }

          img {
            width: 200px;
            height: 200px;
          }

          p {
            color: #969696;
            display: inline-block;
            font-size: 15px;
            font-weight: 300;
            line-height: 20px;
            margin: 5px 0 0;
            overflow: hidden;
            text-shadow: 0 1px 0 #fff;
            text-transform: uppercase;
            width: 100%;
          }
        }
      }
    }
  }
}

.search-list {
  display: none;
  width: 118px;
  max-height: 200px;
  padding: 10px 0;
  overflow-y: auto;
  overflow-x: hidden;
  transition: all 0.5s ease;
  background: #ffffff;

  li {
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #333;
    white-space: nowrap;
    font-size: 14px;
    cursor: pointer;
  }
}

.memberBug {
  position: fixed;
  top: 260px;
  //top: 100px;
  left: 39%;
  z-index: 9000;
}
</style>
